export default __webpack_public_path__ + "static/logo8-197f5388a73cf4749b1db6d13559e46c.svg";